// LEGACY, effectively dead — no in-app navigation reaches this checkout anymore
// (confirmed 2026-07-06); the active flow lives in the React messaging app
// (mobile-app/react/messaging). Stale deep-link routes still resolve here
// (app-routing: penmates/:id/v1/new-message/confirm-order, messages/:message_id/send)
// until the confirm-order module and its routes are deleted.
// Do not review, fix, or extend this page (or postcard-confirm-order.ts); it
// intentionally does NOT receive dynamic pricing changes (e.g. the new-user
// simplified credit ladder in CreditsSheet).
import { Component, OnInit, OnDestroy, ViewEncapsulation, NgZone, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NavController,
  Platform,
  ModalController,
  AlertController,
  LoadingController,
} from '@ionic/angular';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import {  Appearance } from '@angular-material-extensions/google-maps-autocomplete';

import { UserActions, CreateMessageActions, MyPenmateActions, SearchActions } from '../actions';
import {
  AppState,
  LetterService,
  EventService,
  AuthService,
  MyPenmateService,
  NativeClientService,
  mapStates,
  mapCountries,
  DraftManagerService,
  PosthogReplayService,
} from '../services';
import { debounce, get, orderBy, merge, isEmpty, includes, find, isEqual } from 'lodash';
import { LoadingModal } from '../loading-modal/loading-modal';
import { MessageIndexPage } from '../message-index/message-index';
import { CreateMessageReturnAddress } from '../create-message-return-address/create-message-return-address';
import { MyPenmatesPage } from '../my-penmates/my-penmates';
import { AddPaymentSheet } from '../add-payment-sheet/add-payment-sheet';
import { AccountVerificationModal } from '../account-verification-modal/account-verification-modal';
import { AppDownloadModal } from '../app-download-modal/app-download-modal';
import { EmailDeliveryModal } from '../email-delivery-modal/email-delivery-modal';
import { SelectedPhotosModal } from '../selected-photos-modal/selected-photos-modal';

import { Angulartics2GoogleGlobalSiteTag } from 'angulartics2/gst';

import ErrorHandler from '../../lib/error-handler'

import {
  StripeInstance,
  StripeFactoryService,
  StripeService,
} from 'ngx-stripe';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { debounceTime, startWith, distinctUntilChanged, takeWhile, takeUntil, filter, take } from 'rxjs/operators';

import { FormBuilder } from '@angular/forms';
import { StripeAddressComponent, StripeAddressChangeEvent } from '../shared/components/stripe-address/stripe-address.component';
const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

declare var Penmate;
declare var Rollbar;
declare var google;
declare var gtag;

/*
  Generated class for the ConfirmOrder page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'pm-page-confirm-order',
  templateUrl: 'confirm-order.html',
  styleUrls: ['./confirm-order.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ConfirmOrderPage implements OnInit, OnDestroy {
  @ViewChild('stripeAddress', { static: false }) stripeAddressComponent: StripeAddressComponent;
  stripe: StripeInstance;
  public appearance = Appearance;
  currentMessage;
  penmate;
  pageHeight;
  couponCode;
  pageModal;
  paymentRequired = true;
  isPostcard;
  showPromoCodeInput = false;
  showIgPromo = false;
  hideBack = false;
  firstMessage = false;
  currentReplyOption = '';
  returnAddressValid = false;
  addressValidationResult = null; // Store country-specific validation results
  showEditAddress = true;
  GoogleAutocomplete;
  autocomplete;
  autocompleteItems = [];
  user;
  activeSubscription = false;
  pastDueSubscription = false;
  creditTopUp = false;
  onPromo = false;
  loadingTotal = false;
  isDraftSaving = false;
  private addressDraftSave$ = new Subject<void>();
  orderOptionSelected = false;
  freeShipping = false;
  photoCredits = 0;
  STATE_NAMES;
  COUNTRY_NAMES;
  creditOptionForm;
  showEmessageDisabledMsg;
  math = Math;
  creditTopUpRequired = true;
  stripeElements;
  isAddressDataReady = false;
  showEmessageReminder = false;
  totalWithTax = 0;
  regularTotal = 0;
  creditOptionInt = 0;
  currentStateName = '';
  private stateNamesMap: Map<string, string>;
  saveStatus$ = this.draftManager.getSaveStatus();
  private destroy$ = new Subject<void>();
  private confirmOrderTrackedLetterId: number | null = null;

  dpOffersByBundle: any = {};
  dpOfferBadgeTextByBundle: any = {};
  dpOfferLoadedContextKey: string | null = null;
  dpOfferPendingContextKey: string | null = null;
  dpOfferBlockUntilNotSaving = false;
  dpSelectedOffer: any = null;
  dpSelectedOfferSavingsCents = 0;
  dpSelectedOfferOriginalSubtotalCents = 0;
  dpSelectedOfferBonusCredits = 0;
  printMailStashedPhotos = null;

  constructor(
    public navCtrl: NavController,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public route: ActivatedRoute,
    public platform: Platform,
    public store: Store<AppState>,
    public createMessageActions: CreateMessageActions,
    public myPenmateActions: MyPenmateActions,
    public searchActions: SearchActions,
    public letterService: LetterService,
    public myPenmateService:   MyPenmateService,
    public eventService: EventService,
    public userActions: UserActions,
    public authService: AuthService,
    public nativeService: NativeClientService,
    public formBuilder: FormBuilder,
    private stripeFactory: StripeFactoryService,
    private bottomSheet: MatBottomSheet,
    private router: Router,
    public zone: NgZone,
    private cdr: ChangeDetectorRef,
    private draftManager: DraftManagerService,
    private posthogReplay: PosthogReplayService,
  ) {
    this.pageHeight = this.platform.height();

    this.eventService.gaEventTrack('Confirm Order', {
      event_category: 'User',
    });
    this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
    this.autocomplete = { input: '' };
    this.autocompleteItems = [];
    this.STATE_NAMES = mapStates.map(m => m['abbreviation']).sort();
    this.COUNTRY_NAMES = mapCountries.map(m => ({name: m['name'], code: m['code'] }))
      .sort((a, b) => a.name.localeCompare(b.name));
    this.COUNTRY_NAMES = [
      ...this.COUNTRY_NAMES.filter(country => country.code.toLowerCase() === 'us'),
      ...this.COUNTRY_NAMES.filter(country => country.code.toLowerCase() !== 'us')
    ];
    
    // Initialize state names map for O(1) lookup
    this.stateNamesMap = new Map(
      mapStates.map(state => [state.abbreviation.toLowerCase(), state.name])
    );
  }

	  ngOnInit() {
    // On load setup state...
    const url = new URL(window.location.href);
    const paymentIntentClientSecret = url.searchParams.get("setup_intent_client_secret");
    const paymentSucceeded = url.searchParams.get('paymentSucceeded');



    this.stripe = this.stripeFactory.create(Penmate.env.stripeKey);
    this.store
      .select((state) => state.user)
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        this.user = user;

        // Demo users (skipConfirmation) should never enter checkout/payment.
        if (get(user, 'deviceInfo.metrics') === false) {
          const penmateId = this.route.snapshot.paramMap.get('id');
          return this.navCtrl.navigateRoot(penmateId ? `/penmates/${penmateId}/v1/messages` : '/my-penmates');
        }

        if (
          user && user.hasPurchasedCredits === true
        ) {
          this.posthogReplay.stopCheckoutReplay();
        }
        this.updateEmessageReminderVisibility();
        this.updateCalculatedTotals();
        this.updateCreditOptionInt();
        this.updateCurrentStateName();
      });

    this.draftManager
      .getSaveStatus()
      .pipe(takeUntil(this.destroy$))
      .subscribe((status) => {
        this.isDraftSaving = !!status && status.status === 'saving';
        if (!this.isDraftSaving) {
          this.dpOfferBlockUntilNotSaving = false;
          if (this.dpOfferPendingContextKey) {
            this.loadDynamicPricingOffer();
          }
        }
      });

    this.addressDraftSave$
      .pipe(debounceTime(600), takeUntil(this.destroy$))
      .subscribe(() => {
        this.onSaveDraft(0, 'normal', 'return_address_change');
      });

	    this.store
	      .select((state) => state.createMessage)
	      .pipe(takeUntil(this.destroy$))
	      .subscribe((currentMessage) => {
        const previousMessage = this.currentMessage;
        const existingMessageId = get(previousMessage, 'id');
        const nextMessageId = get(currentMessage, 'id');
        const isSameMessage =
          existingMessageId && nextMessageId && existingMessageId === nextMessageId;
        const mergedMessage =
          previousMessage && isSameMessage ? { ...previousMessage, ...currentMessage } : currentMessage;
        const localShippingMethod =
          existingMessageId && nextMessageId && existingMessageId === nextMessageId
            ? get(this.currentMessage, 'shippingMethod')
            : null;
        this.currentMessage = localShippingMethod
          ? { ...mergedMessage, shippingMethod: localShippingMethod }
          : mergedMessage;
        const meta = this.currentMessage.meta || {};
        this.activeSubscription = !!meta.subscription;
        this.onPromo = !!meta.onPromo;
        this.photoCredits = meta.photoCredits || 0;
        this.creditTopUp = this.currentMessage.creditTopUp;
        this.pastDueSubscription = /past_due/i.test(meta.subscription || '');
        this.firstMessage = meta.firstMessage;
        this.freeShipping = meta.freeShipping;
        this.penmate = this.currentMessage.penmate;

        if (this.penmate) {
          this.penmate.showMap = true;
        }
        this.showPromoCodeInput = currentMessage.coupon;
        this.paymentRequired =
          currentMessage.priceAfterCoupon > 0 ||
          (currentMessage.priceAfterCoupon === 0 &&
            this.currentMessage.photo &&
            this.currentMessage.photoType !== 'regular');

        if (this.currentMessage.shippingMethod == 'letter' && meta.letterCreditBalance > 0) {
          const paymentDiff = this.onCalculateRegularTotal() - (meta.letterCreditBalance * 0.01)
          this.paymentRequired = this.onCalcMinTotal(paymentDiff) > 0;
        }
        if (meta.hasLetterCredit) {
          this.paymentRequired = (meta.letterCreditsDue || 0) > (meta.letterCreditAmt || 0);
        }
        if (meta.hasLetterCredit || !meta.hasLetterCredit && this.user.messageCreditsAvailable) {
          this.creditTopUpRequired = (meta.letterCreditsDue || 0) > (meta.letterCreditAmt || 0);
        }
        if (!this.user.has_sent_letter && 
            this.currentMessage.shippingMethod !== 'emessage'
          ) {
              
              this.paymentRequired = this.currentMessage.priceAfterCoupon > 0;
              if (meta.firstMessage) {
                this.creditTopUpRequired = this.currentMessage.photoType == 'glossy'
              } else {
                this.creditTopUpRequired = this.paymentRequired 
              }
            }

        if (!this.user.has_sent_letter && this.currentMessage.shippingMethod == 'emessage') {
          this.paymentRequired = this.currentMessage.priceAfterCoupon > 0;
          this.creditTopUpRequired = true
        }

        if (this.currentMessage.isResend) {
          this.creditTopUpRequired = false;
        }


        this.paymentRequired = this.currentMessage.priceAfterCoupon > 0;
        this.isPostcard = currentMessage.messageType === 'postcard';
        const couponLabel = get(currentMessage, 'coupon.code');
        this.couponCode = currentMessage.coupon ? couponLabel : null;
	        this.updateReturnAddressValidity();
	        this.updateEmessageReminderVisibility();
	        this.updateCalculatedTotals();
	        this.updateCreditOptionInt();
	        this.syncCreditOptionFormFromMessage(this.currentMessage);
	        this.updateCurrentStateName();

		        // New users sending a free print-and-mail message should be able to submit without
		        // going through the first-message interstitial/coupon click flow.
	        if (!this.orderOptionSelected &&
	            (!this.user || !this.user.has_sent_letter) &&
	            (this.currentMessage && this.currentMessage.shippingMethod !== 'emessage') &&
	            !this.paymentRequired) {
	          this.orderOptionSelected = true;
	        }

	        this.loadDynamicPricingOffer();

          if (!!this.creditTopUpRequired) {
            this.posthogReplay.maybeStartCheckoutReplay(this.user, {
              letterId: get(this.currentMessage, 'id'),
              messageType: get(this.currentMessage, 'messageType'),
              shippingMethod: get(this.currentMessage, 'shippingMethod'),
              paymentRequired: !!this.creditTopUpRequired,
            });
          } else {
            this.posthogReplay.stopCheckoutReplay();
          }
	      });

    // Find penmate or redirect
    this.store
      .select((state) => state.createMessage)
      .pipe(
        take(2),
        takeUntil(this.destroy$)
      )
      .subscribe((currentMessage) => {
        const { penmate } = currentMessage;
        // Initial save on component load
        this.draftManager
          .forceSave(currentMessage, { st_eligible: true })
          .subscribe((letter) => this.applySavedLetterToCurrentMessage(currentMessage, letter));
        if (currentMessage.eMessage || currentMessage.messageType === 'postcard') {
          this.orderOptionSelected = true;
        }
        const letterId = get(currentMessage, 'id');
        if (letterId && this.confirmOrderTrackedLetterId !== letterId) {
          this.confirmOrderTrackedLetterId = letterId;
          this.eventService.track('confirm-order', {
            letter_id: letterId,
            penmate_id: get(currentMessage, 'penmate.id'),
            message_type: currentMessage.messageType,
            shipping_method: currentMessage.shippingMethod,
            payment_required: !!this.paymentRequired,
            credit_topup_required: !!this.creditTopUpRequired,
            credit_option: currentMessage.creditOption,
            price: currentMessage.price,
            price_after_coupon: currentMessage.priceAfterCoupon,
            offer_redemption_id: get(currentMessage, 'offerRedemptionId') || null,
            dp_has_offers: this.dpHasOffers(),
          });
        }
        this.currentReplyOption =
          get(currentMessage, 'returnAddress.addressType', '') === 'physical'
            ? 'physical'
            : 'email';
        this.store.dispatch(
          this.createMessageActions.setMessage({
            returnAddress: {
              email: this.user.email,
              ...currentMessage.returnAddress,
            },
          }),
        );
        this.updateReturnAddressValidity();
        if (penmate && penmate.id) {
          this.store.dispatch(this.myPenmateActions.viewPenmate(penmate));
          return this.store.dispatch(this.myPenmateActions.loadMessages(penmate.id));
        }

        // Lookup penmate or redirect
        const penmateId = this.route.snapshot.paramMap.get('id');
        this.store
          .select((state) => state.myPenmates.penmates)
          .pipe(
            take(2),
            takeUntil(this.destroy$)
          )
          .subscribe((penmates) => {

            if (penmates.length === 0 && !paymentIntentClientSecret && !paymentSucceeded) {
              return this.navCtrl.navigateRoot('/penmates');
            }

            const pmate = find(penmates, (p) => p && p.id === parseInt(penmateId, 10));
            if (pmate) {
              this.store.dispatch(this.createMessageActions.setMessage({ penmate: pmate }));
            }
            
            if (!pmate && !paymentIntentClientSecret && !paymentSucceeded) {
              this.navCtrl.navigateRoot('/penmates');
            }
          });
      });

    //

    // on Auth validate/setup user state...
    this.authService.authenticate()
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ isAuthenticated, user }) => {
      if (!isAuthenticated || !user) {
        const route = window.location.pathname.replace(/^\//, '');
        this.store.dispatch(this.searchActions.saveRoute(route));
        return this.navCtrl.navigateRoot('/login');
      }
      this.store.dispatch(this.userActions.loginUser(user));
      if (paymentIntentClientSecret) {
        this.myPenmateService.getPenmates()
          .pipe(takeUntil(this.destroy$))
          .subscribe(penmates => {
          this.store.dispatch(this.myPenmateActions.loadPenmatesSuccess(penmates));
          this.store.dispatch(this.createMessageActions.fetchDrafts());
          this.onAddPayment()
        })
      }

    });



  }

  ionViewDidEnter() {
    this.onSetDefaultReturnAddress();
    this.onSetDefaultShippingMethod();
    this.onAddDefaultPaymentMethod();
    this.updateReturnAddressValidity();
    this.showEditAddress = !this.returnAddressValid;
    this.isAddressDataReady = this.currentMessage.defaultReturnAddress || (this.currentMessage.returnAddress && this.currentMessage.returnAddress.address_line1)
    if (!this.isAddressDataReady) {
      setTimeout(() => {
        this.isAddressDataReady = true;
      }, 1000);
    }

    if (this.user && this.currentMessage && !!this.creditTopUpRequired) {
      this.posthogReplay.maybeStartCheckoutReplay(this.user, {
        letterId: get(this.currentMessage, 'id'),
        messageType: get(this.currentMessage, 'messageType'),
        shippingMethod: get(this.currentMessage, 'shippingMethod'),
        paymentRequired: !!this.creditTopUpRequired,
      });
    }
  }

  ionViewDidLeave() {
    // Ionic can keep pages alive in the nav stack; reset per-view event guards on leave so we
    // still track once per view when the user returns to this checkout.
    this.confirmOrderTrackedLetterId = null;
    this.posthogReplay.stopCheckoutReplay();
  }

  ionViewWillEnter(){
    this.onInitCreditOptionForm();
  }

  private dpOfferContextKey(letterId: number) {
    const shippingMethod =
      this.currentMessage && this.currentMessage.shippingMethod
        ? String(this.currentMessage.shippingMethod)
        : '';
    const messageType =
      this.currentMessage && this.currentMessage.messageType
        ? String(this.currentMessage.messageType)
        : '';
    const photoType =
      this.currentMessage && this.currentMessage.photoType
        ? String(this.currentMessage.photoType)
        : '';
    const couponCode = get(this.currentMessage, 'coupon.code')
      ? String(get(this.currentMessage, 'coupon.code'))
      : '';

    return [letterId, shippingMethod, messageType, photoType, couponCode].join('|');
  }

  private resetDynamicPricingOfferUi() {
    this.dpOffersByBundle = {};
    this.dpOfferBadgeTextByBundle = {};
    this.dpSelectedOffer = null;
    this.dpSelectedOfferSavingsCents = 0;
    this.dpSelectedOfferOriginalSubtotalCents = 0;
    this.dpSelectedOfferBonusCredits = 0;
  }

  private clearDynamicPricingOfferState(clearRedemptionId: boolean = true) {
    this.dpOfferLoadedContextKey = null;
    this.dpOfferPendingContextKey = null;
    this.dpOfferBlockUntilNotSaving = false;
    this.resetDynamicPricingOfferUi();
    if (clearRedemptionId && this.currentMessage && this.currentMessage.offerRedemptionId) {
      this.currentMessage.offerRedemptionId = null;
      this.store.dispatch(this.createMessageActions.setMessage({ offerRedemptionId: null }));
    }
  }

	  private loadDynamicPricingOffer() {
	    const letterId = this.currentMessage && this.currentMessage.id;
	    if (!letterId) return;

    const meta = this.currentMessage && this.currentMessage.meta ? this.currentMessage.meta : {};
    const messageCreditCost = (meta.messageCreditCost || 0);
    const letterCreditsDue = (meta.letterCreditsDue || 0);
    const letterCreditAmt = (meta.letterCreditAmt || 0);
    const messageCreditBalance =
      get(this.user, 'messageCreditBalance') || get(this.user, 'message_credit_balance') || 0;
    const creditPurchaseRequired =
      (letterCreditsDue > letterCreditAmt) || (messageCreditCost > messageCreditBalance);

	    if (!get(this.user, 'has_sent_letter') && this.currentMessage.coupon) {
	      // New user coupon paths (e.g. #sendlove) should not show offers.
	      this.clearDynamicPricingOfferState(true);
	      return;
	    }

		    // Only fetch/render offers when a credit purchase is required.
		    if (!creditPurchaseRequired) {
		      this.clearDynamicPricingOfferState(true);
		      return;
		    }

	    const contextKey = this.dpOfferContextKey(letterId);

	    // If a save is in-flight or queued (common when switching shipping/photo options), avoid
	    // fetching offers against stale server state. We'll retry once saving completes via the
	    // DraftManager save-status subscription.
	    if (this.loadingTotal || this.isDraftSaving || this.dpOfferBlockUntilNotSaving) {
	      this.dpOfferPendingContextKey = contextKey;
	      return;
	    }

    this.dpOfferPendingContextKey = null;

	    // Offers can change when the user switches delivery / photo options; cache by a context key
	    // rather than by letter id alone.
	    if (this.dpOfferLoadedContextKey === contextKey) return;
	    this.dpOfferLoadedContextKey = contextKey;

	    this.letterService.getOffers(letterId)
	      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe((resp: any) => {
        const offers = (resp && resp.displayed_offers) || (resp && resp.recommended_offer ? [resp.recommended_offer] : []) || [];
        const recommendedRedemptionId = resp && resp.recommended_offer ? resp.recommended_offer.redemption_id : null;
        const byBundle: any = {};
        const badgeByBundle: any = {};

        for (let i = 0; i < offers.length; i++) {
          const offer = offers[i];
          if (!offer) continue;
          const bundleKey = String(offer.bundle_size);
          const existing = byBundle[bundleKey];
          byBundle[bundleKey] = this.pickPreferredDpOffer(existing, offer, recommendedRedemptionId);
        }

        for (const bundleKey in byBundle) {
          if (!Object.prototype.hasOwnProperty.call(byBundle, bundleKey)) continue;
          badgeByBundle[bundleKey] = this.buildDpOfferBadgeText(byBundle[bundleKey]);
        }

        this.dpOffersByBundle = byBundle;
        this.dpOfferBadgeTextByBundle = badgeByBundle;
        this.syncDpOfferRedemptionIdWithSelection();
        this.updateDpSelectedOffer();
      }, () => {
        // Network failures shouldn't drop a previously-selected redemption id; keep it sticky
        // and retry on the next state change.
        this.clearDynamicPricingOfferState(false);
      });
  }

  private pickPreferredDpOffer(existing: any, candidate: any, recommendedRedemptionId: string | null) {
    if (!existing) return candidate;
    if (!candidate) return existing;

    const existingRedemptionId = existing && existing.redemption_id ? existing.redemption_id : null;
    const candidateRedemptionId = candidate && candidate.redemption_id ? candidate.redemption_id : null;

    if (recommendedRedemptionId && candidateRedemptionId === recommendedRedemptionId) return candidate;
    if (recommendedRedemptionId && existingRedemptionId === recommendedRedemptionId) return existing;

    const existingBonus = parseInt(existing.bonus_credits, 10) || 0;
    const candidateBonus = parseInt(candidate.bonus_credits, 10) || 0;
    if (candidateBonus !== existingBonus) return candidateBonus > existingBonus ? candidate : existing;

    const existingBundlePrice = parseInt(existing.bundle_price_cents, 10) || 0;
    const candidateBundlePrice = parseInt(candidate.bundle_price_cents, 10) || 0;
    const existingPrice = parseInt(existing.price_cents, 10) || 0;
    const candidatePrice = parseInt(candidate.price_cents, 10) || 0;
    const existingSavings = existingBundlePrice > 0 && existingPrice > 0 ? existingBundlePrice - existingPrice : 0;
    const candidateSavings = candidateBundlePrice > 0 && candidatePrice > 0 ? candidateBundlePrice - candidatePrice : 0;
    if (candidateSavings !== existingSavings) return candidateSavings > existingSavings ? candidate : existing;

    if (candidatePrice !== existingPrice) return candidatePrice < existingPrice ? candidate : existing;

    return existing;
  }

  private buildDpOfferBadgeText(offer: any): string | null {
    if (!offer) return null;
    const bonus = parseInt(offer.bonus_credits, 10) || 0;
    const bundlePrice = parseInt(offer.bundle_price_cents, 10) || 0;
    const price = parseInt(offer.price_cents, 10) || 0;
    const savings = bundlePrice > 0 && price > 0 ? bundlePrice - price : 0;

    if (bonus > 0) return `+${bonus} BONUS CREDITS`;
    if (savings > 0) return `Save $${(savings / 100).toFixed(2)}`;
    return 'Special offer';
  }

  dpOfferUnitPriceText(bundleSize: number, fallbackText: string): string {
    const size = parseInt(String(bundleSize), 10) || 0;
    if (size <= 0) return fallbackText;

    const offer = this.dpOffersByBundle ? this.dpOffersByBundle[String(size)] : null;
    if (!offer) return fallbackText;

    const priceCents = parseInt(offer.price_cents, 10) || 0;
    if (priceCents <= 0) return fallbackText;

    const bonus = parseInt(offer.bonus_credits, 10) || 0;
    const effectiveCredits = size + Math.max(bonus, 0);
    if (effectiveCredits <= 0) return fallbackText;

    const dollarsPerCredit = (priceCents / effectiveCredits) / 100;
    return `$${dollarsPerCredit.toFixed(2)} ea`;
  }

  dpOfferBonusCreditsForBundle(bundleSize: number): number {
    const size = parseInt(String(bundleSize), 10) || 0;
    if (size <= 0) return 0;
    const offer = this.dpOffersByBundle && this.dpOffersByBundle[String(size)] ? this.dpOffersByBundle[String(size)] : null;
    return offer ? (parseInt(offer.bonus_credits, 10) || 0) : 0;
  }

  dpOfferHasBonusForBundle(bundleSize: number): boolean {
    return this.dpOfferBonusCreditsForBundle(bundleSize) > 0;
  }

  dpOfferEffectiveCreditsForBundle(bundleSize: number): number {
    const size = parseInt(String(bundleSize), 10) || 0;
    if (size <= 0) return 0;
    const bonus = this.dpOfferBonusCreditsForBundle(size);
    return size + Math.max(bonus, 0);
  }

  dpOfferPostcardExtraMessagesForBundle(bundleSize: number): number {
    const effectiveCredits = this.dpOfferEffectiveCreditsForBundle(bundleSize);
    return Math.max(effectiveCredits - 3, 0);
  }

  dpHasOffers(): boolean {
    if (!this.dpOffersByBundle) return false;
    for (const bundleKey in this.dpOffersByBundle) {
      if (!Object.prototype.hasOwnProperty.call(this.dpOffersByBundle, bundleKey)) continue;
      if (this.dpOffersByBundle[bundleKey]) return true;
    }
    return false;
  }

  private defaultCreditOptionForDraft(draft: any): string | null {
    if (!draft) return null;

    const isPostcard = draft && draft.messageType === 'postcard';
    const shippingMethod = draft && draft.shippingMethod ? String(draft.shippingMethod) : null;
    const selectedPhotos = draft && draft.selectedPhotos ? draft.selectedPhotos : [];
    const photoCount = Array.isArray(selectedPhotos) ? selectedPhotos.length : 0;

    const meta = draft && draft.meta ? draft.meta : {};
    const messageCreditCost = meta && meta.messageCreditCost != null ? parseInt(meta.messageCreditCost, 10) : 0;
    const letterCreditsDue = meta && meta.letterCreditsDue != null ? parseInt(meta.letterCreditsDue, 10) : 0;
    const messageCreditBalance =
      get(this.user, 'messageCreditBalance') || get(this.user, 'message_credit_balance') || 0;
    const balance = parseInt(String(messageCreditBalance), 10) || 0;

    if (shippingMethod !== 'emessage') return null;

    // Only set a default creditOption when a purchase is actually required; otherwise, leaving it
    // unset avoids accidentally applying "single-credit" promo semantics to users with enough credits.
    if (!isPostcard && photoCount <= 1) {
      const due = 1;
      return balance >= due ? null : '1';
    }

    const computedDue = (!isPostcard && photoCount > 1) ? (1 + Math.min(photoCount, 4)) : 0;
    const creditsDue = (messageCreditCost || letterCreditsDue || computedDue || (isPostcard ? 3 : 0)) || 0;
    const creditsNeeded = Math.max(creditsDue - balance, 0);
    if (creditsNeeded <= 0) return null;

    if (creditsNeeded <= 5) return '5';
    if (creditsNeeded <= 10) return '10';
    return '15';
  }

	  private syncDpOfferRedemptionIdWithSelection() {
	    if (!this.currentMessage) return;

	    const selected = parseInt(this.currentMessage.creditOption, 10);
	    const offer = this.dpOffersByBundle && selected ? this.dpOffersByBundle[String(selected)] : null;
	    const offerRedemptionId = (offer && offer.redemption_id) ? offer.redemption_id : null;

	    if (this.currentMessage.offerRedemptionId === offerRedemptionId) return;

	    this.currentMessage.offerRedemptionId = offerRedemptionId;
	    this.store.dispatch(this.createMessageActions.setMessage({ offerRedemptionId }));
	    this.onSaveDraft(250, 'normal', 'dp_offer_redemption_sync');
	    this.updateDpSelectedOffer();
	  }

	  private updateDpSelectedOffer() {
	    const selected = this.currentMessage ? parseInt(this.currentMessage.creditOption, 10) : 0;
	    const offer = this.dpOffersByBundle && selected ? this.dpOffersByBundle[String(selected)] : null;

    this.dpSelectedOffer = offer;

    if (!offer) {
      this.dpSelectedOfferSavingsCents = 0;
      this.dpSelectedOfferOriginalSubtotalCents = 0;
      this.dpSelectedOfferBonusCredits = 0;
      return;
    }

    const bundlePrice = parseInt(offer.bundle_price_cents, 10) || 0;
    const offerPrice = parseInt(offer.price_cents, 10) || 0;
    const bonus = parseInt(offer.bonus_credits, 10) || 0;

    this.dpSelectedOfferOriginalSubtotalCents = bundlePrice;
    this.dpSelectedOfferSavingsCents = bundlePrice > 0 && offerPrice > 0 ? Math.max(bundlePrice - offerPrice, 0) : 0;
    this.dpSelectedOfferBonusCredits = bonus;
  }

  onAddressChanged(changeEvent: StripeAddressChangeEvent) {
    this.store
      .select(({ createMessage }) => ({ createMessage }))
      .pipe(
        take(1),
      )
      .subscribe(({ createMessage: currentMessage }) => {
        this.store.dispatch(
          this.createMessageActions.setMessage({
            returnAddress: {
              addressType: 'email',
              ...(currentMessage.returnAddress || {}),
              ...changeEvent.value,
            },
          }),
        );
        this.updateReturnAddressValidity();
        this.updateCurrentStateName();
        if (changeEvent.complete) {
          this.addressDraftSave$.next();
        }
      });
    
    this.cdr.detectChanges();
  }

	  onInitCreditOptionForm() {
	    // Initialize credit option form only once; keep in sync via store subscription.
	    if (this.creditOptionForm) {
	      this.syncCreditOptionFormFromMessage(this.currentMessage);
	      return;
	    }
	    
	    this.store
	    .select(({ createMessage }) => ({ createMessage }))
	    .pipe(
	      take(1), // Only take first emission
	      takeUntil(this.destroy$)
	    )
	    .subscribe(({ createMessage: currentMessage }) => {
	      const photos = currentMessage.selectedPhotos || []
	      const mailboxEnabled = get(currentMessage, 'meta.mailboxEnabled') || false
	      const isPostcard = currentMessage && currentMessage.messageType === 'postcard';
	      const defaultCreditAmt = (mailboxEnabled || (isPostcard && !get(this.user, 'has_sent_letter'))) ? '1' : '5';
	      let defaultOption = (photos.length > 1 && !isPostcard) ? '5' : defaultCreditAmt;
	      if (get(currentMessage, 'meta.letterCreditsDue', 0) > 5) {
	        defaultOption = '10';
	      }
	      const persistedOption = currentMessage && currentMessage.creditOption ? String(currentMessage.creditOption) : null;
	      const initialOption = persistedOption || defaultOption;
	      this.creditOptionForm = this.formBuilder.group({
	        creditOption: [initialOption],
	      });

	      this.creditOptionForm.valueChanges.pipe(
	        distinctUntilChanged(),
	        startWith(this.creditOptionForm.value),
	        takeUntil(this.destroy$)
	      ).subscribe(({ creditOption }) => {
	        if (creditOption && creditOption !== this.currentMessage.creditOption) {
	          this.currentMessage.creditOption = creditOption;
	          const selected = parseInt(creditOption, 10);
	          const offer = this.dpOffersByBundle && selected ? this.dpOffersByBundle[String(selected)] : null;
	          const offerRedemptionId = (offer && offer.redemption_id) ? offer.redemption_id : null;
	          this.currentMessage.offerRedemptionId = offerRedemptionId;
	          this.updateDpSelectedOffer();

	          this.store.dispatch(this.createMessageActions.setMessage({ creditOption, offerRedemptionId }));
	          this.updateCreditOptionInt();
	          this.loadingTotal = true;
	          // User-initiated change - save with normal priority
	          this.onSaveDraft(1000);
	        }
	        this.store
	        .select((state) => state.createMessage)
	        .pipe(
	          debounceTime(1200),
	          take(1),
	          takeUntil(this.destroy$)
	        )
	        .subscribe(() => {
	          this.loadingTotal = false;
	        });

	      });
	    })
	  }

	  private syncCreditOptionFormFromMessage(message: any): void {
	    if (!this.creditOptionForm || !message) {
	      return;
	    }
	    const control = this.creditOptionForm.get('creditOption');
	    if (!control) {
	      return;
	    }
	    const desired = message.creditOption ? String(message.creditOption) : null;
	    if (!desired) {
	      return;
	    }
	    if (control.value !== desired) {
	      control.setValue(desired, { emitEvent: false });
	    }
	  }
  
  onAddDefaultPaymentMethod() {
    this.authService.getPaymentMethod()
      .pipe(
        take(1), // Only get payment method once
        takeUntil(this.destroy$)
      )
      .subscribe((payment) => {
        this.store
          .select(({ createMessage, user }) => ({ createMessage, user }))
          .pipe(
            take(1), // Only take the first emission
            takeUntil(this.destroy$),
            filter(({ createMessage: currentMessage, user }) => 
              !currentMessage.payment && user.saveBilling && !user.messageCreditsAvailable
            )
          )
          .subscribe(({ createMessage: currentMessage, user }) => {
            // Only update payment if we have a payment and it's different
            if (payment && !isEqual(currentMessage.payment, payment)) {
              // Just update the store - no need to save during initialization
              const coupon = !user.hasSentLetter ? currentMessage.coupon : null
              this.currentMessage.coupon = coupon;
              this.currentMessage.payment = payment;
              this.store.dispatch(
                this.createMessageActions.setMessage({
                  payment,
                  coupon,
                })
              );
            }
          });
      });
  }

  onSetDefaultReturnAddress = () => {
    this.store
      .select(({ createMessage }) => ({ createMessage }))
      .pipe(
        take(1), // Only take the first emission
        takeUntil(this.destroy$) // Ensure cleanup
      )
      .subscribe(({ createMessage: currentMessage }) => {
        const defaultReturnAddress = get(currentMessage, 'defaultReturnAddress') || {};
        // Only set default if no return address exists
        if (
          !get(currentMessage, 'returnAddress.email_address_line1') &&
          !get(currentMessage, 'returnAddress.address_line1') &&
          (defaultReturnAddress.address_line1 || defaultReturnAddress.email_address_line1)
        ) {
          this.store.dispatch(
            this.createMessageActions.setMessage({
              returnAddress: defaultReturnAddress,
            }),
          );
          this.updateReturnAddressValidity();
          this.updateCurrentStateName();
          // No save needed here - this is just initialization
        }
      });
  };

  onSetDefaultShippingMethod = () => {
    this.store
      .select(({ createMessage, user }) => ({ createMessage, user }))
      .pipe(
        take(1), // Only take the first emission
        takeUntil(this.destroy$) // Ensure cleanup
      )
      .subscribe(({ createMessage: currentMessage, user }) => {
        let shippingMethodChanged = false;
        
        if (currentMessage.messageType === 'postcard') {
          if (this.currentMessage.shippingMethod !== 'letter') {
            this.currentMessage.shippingMethod = 'letter';
            this.currentMessage.eMessage = null;
            shippingMethodChanged = true;
          }
          return;
        }
        
        const expectedShippingMethod = this.currentMessage.eMessage ? 'emessage' : 'letter';
        if (this.currentMessage.shippingMethod !== expectedShippingMethod) {
          this.currentMessage.shippingMethod = expectedShippingMethod;
          shippingMethodChanged = true;
        }
        
        if (this.currentMessage.shippingMethod == 'emessage' && !this.currentMessage.meta.mailboxEnabled && user && user.hasSentEmessage && user.sentLetterTotal <= 2) {
          this.currentMessage.shippingMethod = 'letter';
          this.showEmessageDisabledMsg = true;
          shippingMethodChanged = true;
        }
        
        // Only dispatch update if shipping method actually changed
        if (shippingMethodChanged) {
          this.store.dispatch(
            this.createMessageActions.setMessage({
              shippingMethod: this.currentMessage.shippingMethod,
              eMessage: this.currentMessage.eMessage
            })
          );
        }
      })
  };

  onAddPayment() {
    const url = new URL(window.location.href);
    const messageId = url.searchParams.get("messageId");
    if (messageId && messageId.length) {
      return this.letterService.getLetterWithPenmate(messageId).subscribe( async ({ letter, penmate }) => {
        this.store.dispatch(
          this.createMessageActions.setMessage({
            ...letter,
            penmate
          }),
        );
        this.store
        .select(({ createMessage }) => ({ createMessage }))
        .pipe(takeWhile(({ createMessage: currentMessage }) => !currentMessage || currentMessage.id !== parseInt(messageId), true))
        .subscribe(() => {
          this.onOpenPaymentModal();
        })
      }, async () => {
        const alert = await this.alertCtrl.create({
          header: `Payment Error`,
          cssClass: 'error-alert',
          message: 'There was an error processing your payment',
          buttons: [
            {
              text: 'Try Again',
              handler: () => {
                this.onCancel()
              },
            },
          ],
        });
        return alert.present();
      }) 
    }
    return this.onOpenPaymentModal();
  }

	onOpenPaymentModal = () => {
    const url = new URL(window.location.href);
    const paymentIntentClientSecret = url.searchParams.get("setup_intent_client_secret");
    const messageId = url.searchParams.get("messageId");
    const isEmessage = /emessage/i.test(this.currentMessage.shippingMethod)
    const creditOption = this.currentMessage.creditOption;
    const paymentDescription =  !!creditOption && this.creditTopUpRequired ?  `${creditOption} ${parseInt(creditOption) > 1 ? 'credits' : 'credit'}` : null;
    const sheetRef = this.bottomSheet.open(AddPaymentSheet, {
      data: {
        creditTopUp: this.creditTopUp,
        creditOption,
        amount: this.onCalculateTotalWithTax(),
        processingFee: this.currentMessage.meta.processingFee * 0.01,
        letterId: this.currentMessage.id,
        user: this.user,
        paymentDescription,
      },
      panelClass: 'payment-sheet',
    });


    sheetRef.afterDismissed().subscribe(async (currMessage) => {
      this.orderOptionSelected = true;
      this.showEditAddress = false;
      if (currMessage && currMessage.payment)  {
        this.currentMessage.payment = currMessage.payment;
        this.currentMessage.shippingMethod = currMessage.shippingMethod
        this.currentMessage.coupon = null;
        this.onSaveDraft(250, 'critical', 'payment_update', true)
      }
      if (paymentIntentClientSecret) {
        if (isEmpty(this.currentMessage.penmate) || !this.currentMessage.penmate.id || messageId && parseInt(messageId) !== this.currentMessage.id) {
      
          return this.letterService.getLetterWithPenmate(messageId).subscribe( async ({ letter, penmate }) => {
            this.store.dispatch(
              this.createMessageActions.setMessage({
                ...letter,
                penmate
              }),
            );
            const alert = await this.alertCtrl.create({
              header: `Review your message`,
              backdropDismiss: false,
              message: 'Your payment method has been updated. Please double-check your message before sending.',
              buttons: [
                {
                  text: 'Ok, got it',
                  handler: () => {
                    const routePath = window.location.pathname.split('/confirm-order')[0]
                    this.router.navigateByUrl(routePath);
                  },
                },
              ],
            })
            return alert.present()
          })
        }
      }
    });
  }

  onEmailReturnAddressChanged(event, label) {
    this.store.dispatch(
      this.createMessageActions.setMessage({
        returnAddress: {
          ...get(this.currentMessage, 'returnAddress', {}),
          addressType: 'email',
          [label]: event.target.value,
        },
      }),
    );
  }

  onReturnAddressAutocompleteChange = (value) => {
    this.onEmailReturnAddressChanged({ target: { value } }, 'email_address_line1');
  };

  onAutocompleteSelected(result) {
    const address_components = get(result, 'address_components', []);
    if (isEmpty(address_components)) {
      return;
    }
    const cityData = find(address_components, ({ types }) => includes(types, 'locality'));
    const stateData = find(address_components, ({ types }) =>
      includes(types, 'administrative_area_level_1'),
    );
    const zipData = find(address_components, ({ types }) => includes(types, 'postal_code'));
    let formatted_address = get(result, 'formatted_address');
    formatted_address = !isEmpty(formatted_address)
      ? formatted_address.replace(', USA', '')
      : formatted_address;
    const address = {
      email_address_line1: formatted_address,
      address_city: get(cityData, 'short_name'),
      address_state: get(stateData, 'short_name'),
      address_zip: get(zipData, 'short_name'),
      formatted_address,
    };
    this.store.dispatch(
      this.createMessageActions.setMessage({
        returnAddress: {
          ...get(this.currentMessage, 'returnAddress', {}),
          addressType: 'email',
          ...address,
        },
      }),
    );
    this.updateReturnAddressValidity();
  }

  async onSubmitAddress() {
    // Trigger validation to show any errors if the form is somehow submitted while invalid
    if (this.stripeAddressComponent) {
      await this.stripeAddressComponent.triggerValidation();
      
      // Double-check validity after triggering validation
      if (!this.stripeAddressComponent.isValid()) {
        return;
      }
    }
    
    this.showEditAddress = false;
    this.store.dispatch(
      this.createMessageActions.setMessage({
        returnAddress: {
          ...get(this.currentMessage, 'returnAddress', {}),
          addressType: 'email',
        },
      }),
    );
    this.updateReturnAddressValidity();
    this.onSaveDraft(350);
    this.eventService.track('return-address-saved', {
      addressType: 'email',
      letter: this.currentMessage.id,
    });
  }

  onToggleEmailDelivery() {
    this.loadingTotal = false;
    this.couponCode = null;
    this.currentMessage.coupon = null;
    this.onShowEmailDeliveryModal();
  }

  onShowEmailDeliveryModal() {
    return new Promise(async (resolve, reject) => {
      this.modalCtrl
        .create({
          component: EmailDeliveryModal,
        })
        .then(async (modal) => {
          await modal.present();
          modal.onDidDismiss().then((payload: any) => {
            const addCredits = get(payload, 'data.addCredits');
            // process payload
          });
        })
        .finally(() => {
          resolve(null);
        });
    });
  }

  onGetStateName(stateAbbreviation) {
    const stateData =  mapStates.find((state) => state.abbreviation.toLowerCase() === stateAbbreviation.toLowerCase());
    if (stateData) {
      return stateData.name;
    }
    return stateAbbreviation;
  }


  onTogglePremiumUpgrade(isSubscription = false) {
    this.loadingTotal = false;

    // this.onChangeShipping({ detail: { value: 'letter' } });
    if (!isSubscription || this.activeSubscription) {
      if ( this.activeSubscription ||
        (!this.user.has_sent_letter &&
          !this.isPostcard)
      ) {
        if (!this.isPostcard &&  this.currentMessage && this.currentMessage.shippingMethod !== 'emessage') {
          this.couponCode = null;
          this.currentMessage.coupon = null;
          this.orderOptionSelected = true;
          this.onSavePaymentOption(false)
          return this.onSendEmessage();
        }
        return;
      }
      this.couponCode = null;
      this.currentMessage.coupon = null;
      this.orderOptionSelected = true;
      if (!this.isPostcard && !this.user.has_sent_letter) {
        this.onChangeShipping({ detail: { value: 'emessage' } }, true);
      }
      return this.onSavePaymentOption(false);
    }
  }

  onSavePaymentOption(isCreditTopUp) {
    this.creditTopUp = isCreditTopUp;
    this.currentMessage.isCreditTopUp = this.creditTopUp;
    this.loadingTotal = true;
    this.store.dispatch(
      this.createMessageActions.setMessage({
        creditTopUp: this.creditTopUp,
      }),
    );
    this.onSaveDraft(250);
    this.store
      .select((state) => state.createMessage)
      .pipe(debounceTime(800))
      .subscribe(() => {
        this.loadingTotal = false;
        this.updateCalculatedTotals();
      });
  }

  onReturnAddressInfo = async () => {
    this.eventService.track('show-return-address-info');
    const alert = await this.alertCtrl.create({
      header: `Email Replies`,
      cssClass: 'return-address-info',
      message: `
      Use this option if you would like replies delivered to your e-mail (requires approval). <br/><br/> If you would like
       ${this.penmate.name} to write back to you via mail, choose "Add Return Address".`,
      buttons: [
        {
          text: 'OK',
        },
      ],
    });
    await alert.present();
  };


  onConfirmEmessage = async () => {
    this.eventService.track('emessage-confirm-alert');
    const message = `E-messages may be reviewed by the facility.  If your message
        is unable to be delivered by E-message it will be delivered by USPS Mail. <br/><br/> Do not
        send anything inappropriate or your message may be rejected. <span>You will be notified
        by email when your message is delivered.</span>`

    const alert = await this.alertCtrl.create({
      header: `Reminder`,
      cssClass: 'reminder-alert',
      message,
      buttons: [

        {
          text: 'Cancel',
          handler: () => {
            this.eventService.track('emessage-cancel');
          }
        },
        {
          text: 'OK, Send',
          handler: () => {
            this.onSubmit({ confirm: true})
          },
        },
      ],
    });
    await alert.present();
  };


  onConfirmSendMessage = async () => {
    this.eventService.track('message-send-confirm');
    const message = `Are you ready to send this message?`

    const alert = await this.alertCtrl.create({
      header: `Send Message`,
      cssClass: 'reminder-alert confirm-message-alert',
      message,
      buttons: [

        {
          text: 'Cancel',
          handler: () => {
            this.eventService.track('message-send-cancel');
          }
        },
        {
          text: 'Yes, send',
          handler: () => {
            this.onSubmit({ confirm: true})
          },
        },
      ],
    });
    await alert.present();
  };


  onToggleFirstMessageCoupon = async () => {
    this.loadingTotal = true;
    const loading = await this.loadingCtrl.create({ spinner: 'dots' });
    await loading.present();
    this.couponCode = '#sendlove';
    this.firstMessage = true;
    this.orderOptionSelected = true;
    this.letterService.addCoupon(this.couponCode).subscribe((resp) => {
      loading.dismiss();
      this.loadingTotal = false;
      // Force letter for first message coupon (shippingMethod is a local-only field in this component)
      this.currentMessage.shippingMethod = 'letter';
      this.creditTopUp = false;
      this.currentMessage.isCreditTopUp = false;
      const nextDraftWithCoupon = {
        ...this.currentMessage,
        coupon: (resp as any).coupon,
        shippingMethod: 'letter',
        photoType: 'regular',
        creditTopUp: false,
        payment: null,
      };
      this.store.dispatch(this.createMessageActions.setMessage({
        coupon: nextDraftWithCoupon.coupon,
        photoType: nextDraftWithCoupon.photoType,
        creditTopUp: nextDraftWithCoupon.creditTopUp,
        payment: nextDraftWithCoupon.payment,
      }));
      this.store.dispatch(this.createMessageActions.saveDraft(nextDraftWithCoupon, { st_eligible: true }));
    });
  };

  onReplyOptionChange = (event) => {
    const value = event.target.value;
    this.currentReplyOption = value;
    this.showEditAddress = true;
    this.store.dispatch(
      this.createMessageActions.setMessage({
        returnAddress: {
          ...get(this.currentMessage, 'returnAddress', {}),
          addressType: value,
        },
      }),
    );
    this.updateReturnAddressValidity();
  };

  onReturnAddressEmailChange = (event) => {
    const value = event.target.value;
    this.store.dispatch(
      this.createMessageActions.setMessage({
        returnAddress: {
          ...get(this.currentMessage, 'returnAddress', {}),
          addressType: 'email',
          email: value,
        },
      }),
    );
    this.updateReturnAddressValidity();
  };

  onReturnAddressMailingAddressChange = (event) => {
    const value = event.target.value;
    this.store.dispatch(
      this.createMessageActions.setMessage({
        returnAddress: {
          ...get(this.currentMessage, 'returnAddress', {}),
          addressType: 'email',
          email_address_line1: value,
        },
      }),
    );
    this.updateReturnAddressValidity();
  };

  onReturnAddressNameChange = (event, nameType) => {
    const value = event.target.value;
    const nameParts = {
      firstName: nameType === 'first' ? value : get(this.currentMessage, 'returnAddress.firstName'),
      lastName: nameType === 'last' ? value : get(this.currentMessage, 'returnAddress.lastName'),
    };
    this.store.dispatch(
      this.createMessageActions.setMessage({
        returnAddress: {
          ...get(this.currentMessage, 'returnAddress', {}),
          addressType: 'email',
          ...nameParts,
          name:
            !isEmpty(nameParts.firstName) && !isEmpty(nameParts.lastName)
              ? `${nameParts.firstName} ${nameParts.lastName}`
              : null,
        },
      }),
    );
    this.updateReturnAddressValidity();
  };

  onToggleReturnAddressButton = (addressValid) => {
    // if (!!addressValid && this.currentReplyOption === 'physical') {
    //   return;
    // }
    this.currentReplyOption = 'physical';
    this.onAddReturnAddress();
  };

  onAddReturnAddress = async () => {
    this.showEditAddress = true;
    if (this.currentReplyOption === 'email') {
      setTimeout(() => {
        if (this.stripeAddressComponent) {
          this.stripeAddressComponent.reinitialize();
        }
      }, 800);
      return;
    }
    this.eventService.track('show-add-return-address');
    this.currentReplyOption = 'physical';
    const penmateId = this.route.snapshot.paramMap.get('id');
    this.pageModal = await this.modalCtrl.create({
      component: CreateMessageReturnAddress,
      componentProps: { penmateId },
    });
    this.store.dispatch(
      this.createMessageActions.setMessage({
        returnAddress: {
          ...get(this.currentMessage, 'returnAddress', {}),
          addressType: 'physical',
        },
      }),
    );
    this.updateReturnAddressValidity();
    this.eventService.track('return-address-saved', {
      addressType: 'physical',
      letter: this.currentMessage.id,
    });
    await this.pageModal.present();
  };

  private updateReturnAddressValidity() {
    const returnAddress = this.currentMessage && this.currentMessage.returnAddress;
    if (!returnAddress) {
      this.returnAddressValid = false;
      return;
    }

    // Use country-specific validation if we have the Stripe component
    if (this.stripeAddressComponent) {
      const validation = this.stripeAddressComponent.validateAddressForCountry(returnAddress);
      this.returnAddressValid = validation.isValid;
      
      // Store validation results for potential UI feedback
      this.addressValidationResult = validation;
      return;
    }

    // Fallback to enhanced validation logic
    const firstName = get(returnAddress, 'firstName');
    const lastName = get(returnAddress, 'lastName');
    const name = get(returnAddress, 'name');
    const addressLine1 = get(returnAddress, 'address_line1');
    const addressCity = get(returnAddress, 'address_city');
    const addressState = get(returnAddress, 'address_state');
    const addressZip = get(returnAddress, 'address_zip');
    const addressCountry = get(returnAddress, 'address_country', 'US').toUpperCase();
    
    // Name validation
    const nameFieldsValid = (!isEmpty(firstName) && firstName.replace(/\./g, "").length > 1 && !isEmpty(lastName));
    const nameValid = !isEmpty(name);
    
    // Basic address fields (required for all countries)
    const basicFieldsValid = !isEmpty(addressLine1) && !isEmpty(addressCity);
    
    // Country-specific requirements
    const countryRequirements = this.getCountryAddressRequirements(addressCountry);
    const stateValid = countryRequirements.requiresState ? !isEmpty(addressState) : true;
    const postalCodeValid = countryRequirements.requiresPostalCode ? !isEmpty(addressZip) : true;
    
    this.returnAddressValid = (nameFieldsValid || nameValid) && basicFieldsValid && stateValid && postalCodeValid;
  }

  /**
   * Get address requirements for a specific country (fallback method)
   */
  private getCountryAddressRequirements(countryCode: string): {requiresState: boolean, requiresPostalCode: boolean} {
    const requiresState = ['US', 'CA', 'AU', 'JP', 'IN', 'BR', 'MX'].includes(countryCode);
    const requiresPostalCode = countryCode !== 'HK'; // Most countries require postal code except HK
    
    return {
      requiresState,
      requiresPostalCode
    };
  }

  /**
   * Get user-friendly display name for address field
   */
  getFieldDisplayName(fieldName: string): string {
    const fieldNames = {
      'name': 'Full Name',
      'address_line1': 'Street Address',
      'city': 'City',
      'state': 'State/Province/Region',
      'postal_code': 'Postal/ZIP Code'
    };
    
    return fieldNames[fieldName] || fieldName;
  }

  private updateEmessageReminderVisibility() {
    if (!this.currentMessage || !this.user) {
      this.showEmessageReminder = false;
      return;
    }
    
    this.showEmessageReminder = !this.isPostcard && 
      !this.currentMessage.isResend && 
      this.currentMessage.shippingMethod !== 'emessage' && 
      (this.currentMessage.price > 0 || !this.user.hasSentEmessage) &&
      !!this.currentMessage.emessageAvailable;
  }

  private updateCalculatedTotals() {
    if (!this.currentMessage) {
      this.totalWithTax = 0;
      this.regularTotal = 0;
      return;
    }

    // Calculate regularTotal
    const { processingFee } = get(this.currentMessage, 'meta', {});
    this.regularTotal = this.onCalculateTotal() + (processingFee * 0.01);

    // Calculate totalWithTax
    const subtotal = this.regularTotal;
    
    if (this.couponCode && 
      get(this.currentMessage, 'meta.firstMessage') &&
      !this.isPostcard && 
      !this.user.has_sent_letter && 
      this.currentMessage.shippingMethod != 'emessage' &&
      this.currentMessage.photoType == 'regular'
    ) {
      this.totalWithTax = 0;
    } else {
      this.totalWithTax = subtotal;
    }
  }

  private updateCreditOptionInt() {
    this.creditOptionInt = this.currentMessage && this.currentMessage.creditOption ? parseInt(this.currentMessage.creditOption) : 0;
  }

  private updateCurrentStateName() {
    const stateAbbr = this.currentMessage && this.currentMessage.returnAddress && this.currentMessage.returnAddress.address_state;
    if (stateAbbr) {
      this.currentStateName = this.stateNamesMap.get(stateAbbr.toLowerCase()) || stateAbbr;
    } else {
      this.currentStateName = '';
    }
  }

  isReturnAddressValid = () => {
    return this.returnAddressValid;
  };

  get isSubmitAddressDisabled(): boolean {
    // Check basic return address validity first
    if (!this.returnAddressValid) {
      return true;
    }
    
    // If we're showing the email address form with stripe component, check its validity
    if (this.showEditAddress && this.currentReplyOption === 'email' && this.stripeAddressComponent) {
      return !this.stripeAddressComponent.isValid();
    }
    
    return false;
  }

  returnAddressMissingFields = () => {
    const firstName = get(this.currentMessage, 'returnAddress.firstName');
    const lastName = get(this.currentMessage, 'returnAddress.lastName');
    const name = get(this.currentMessage, 'returnAddress.name');
    const addressLine1 = get(this.currentMessage, 'returnAddress.address_line1');
    const addressCity = get(this.currentMessage, 'returnAddress.address_city');
    const addressState = get(this.currentMessage, 'returnAddress.address_state');
    const addressZip = get(this.currentMessage, 'returnAddress.address_zip');
    const email = get(this.currentMessage, 'returnAddress.email', '');
    const isValid =  ( (!isEmpty(firstName) && firstName.replace(/\./g, "").length > 1 && !isEmpty(lastName)) || !isEmpty(name)) && !isEmpty(addressLine1)

    return {
      firstName,
      lastName,
      name,
      addressLine1,
      addressCity,
      addressState,
      addressZip,
      email,
      isValid,
    }
  }

  onSaveDraft = (timeout = 0, priority: 'critical' | 'normal' | 'low' = 'normal', trigger = 'manual_save', force = false) => {

    if (this.currentMessage.meta.hasLetterCredit) {
      this.paymentRequired = this.currentMessage.meta.letterCreditsDue > this.currentMessage.meta.letterCreditAmt;
    }
    const letterId = this.currentMessage && this.currentMessage.id;
    if (letterId) {
      this.dpOfferBlockUntilNotSaving = true;
      this.dpOfferPendingContextKey = this.dpOfferContextKey(letterId);
    }
    setTimeout(() => {
      if (force) {
        // Force save bypasses deduplication - use for critical saves
        const draftSnapshot = { ...this.currentMessage };
        this.store.dispatch(this.createMessageActions.setMessage(draftSnapshot));
        this.draftManager
          .forceSave(draftSnapshot, { st_eligible: true })
          .subscribe((letter) => this.applySavedLetterToCurrentMessage(draftSnapshot, letter));
      } else {
        this.store.dispatch(
          this.createMessageActions.saveDraft(this.currentMessage, { st_eligible: true })
        );
      }
    }, timeout);
  };

  onSendEmessage() {
    this.pageModal = this.modalCtrl
      .create({
        component: EmailDeliveryModal,
        componentProps: {
          penmateData: this.currentMessage ? this.currentMessage.penmate : null,
        }
      })
      .then(async (modal) => {
        await modal.present();
          modal.onDidDismiss().then((payload: any) => {
            this.zone.run(() => {
              const eMessage = get(payload, 'data.eMessage');
              const canceled = get(payload, 'data.cancel');
              const shippingMethod = canceled
                ? 'letter'
                : eMessage
                  ? 'emessage'
                  : this.currentMessage.shippingMethod;
              this.currentMessage.shippingMethod = shippingMethod;
              const letterId = this.currentMessage && this.currentMessage.id;
              if (letterId) {
                // Prevent offer fetches against stale server state while this draft save is in-flight.
                this.dpOfferBlockUntilNotSaving = true;
                this.dpOfferPendingContextKey = this.dpOfferContextKey(letterId);
              }
              const nextDraft = {
                ...this.currentMessage,
                shippingMethod,
                eMessage: eMessage || this.currentMessage.eMessage,
              };

              if (!nextDraft.creditOption) {
                const defaultCreditOption = this.defaultCreditOptionForDraft(nextDraft);
                if (defaultCreditOption) {
                  nextDraft.creditOption = defaultCreditOption;
                  this.currentMessage.creditOption = defaultCreditOption;
                  this.updateCreditOptionInt();
                }
              }

              this.store.dispatch(
                this.createMessageActions.setMessage({
                  shippingMethod: nextDraft.shippingMethod,
                  eMessage: nextDraft.eMessage,
                  creditOption: nextDraft.creditOption,
                }),
              );
              this.store.dispatch(this.createMessageActions.saveDraft(nextDraft, { st_eligible: true }));
            });
          });
      })
  }

  onShowSelectedPhotos = async () => {
    this.pageModal = await this.modalCtrl.create({
      component: SelectedPhotosModal,
      componentProps: {
        photos: this.currentMessage.selectedPhotos,
      },
    });
    await this.pageModal.present({ updateUrl: false });
  };

  hasPhotos() {
    return this.currentMessage.selectedPhotos && this.currentMessage.selectedPhotos.length > 0;
  }

  photoPrintingRadioValue(): string {
    const fallback =
      this.currentMessage && this.currentMessage.photoType
        ? String(this.currentMessage.photoType)
        : 'regular';

    if (!this.user || this.user.has_sent_letter) return fallback;
    if (!this.currentMessage) return fallback;
    if (this.currentMessage.shippingMethod !== 'letter') return fallback;
    if (this.isPostcard || this.currentMessage.isResend) return fallback;

    const coupon = this.currentMessage.coupon;
    const code = coupon && coupon.code ? String(coupon.code).toLowerCase() : '';
    if (code.indexOf('sendlove') >= 0) return 'none';

    return fallback;
  }

  onChangeEmessage = (evt) => {
    if (this.currentMessage.eMessage) {
      this.loadingTotal = true;
      const shippingMethod = 'emessage';
      this.currentMessage.shippingMethod = shippingMethod
      this.store.dispatch(this.createMessageActions.setMessage({ shippingMethod }));
      this.onSaveDraft();
      this.store
        .select((state) => state.createMessage)
        .pipe(debounceTime(1200))
        .subscribe(() => {
          this.loadingTotal = false;
        });
      return setTimeout(() => {
        this.currentMessage.shippingMethod = shippingMethod;
      }, 1500)
    }
    this.onSendEmessage()
  }


  onChangeShipping = (evt, force = false) => {
    const shippingMethod = get(evt, 'detail.value');
    if (!shippingMethod) { return; }

    if (shippingMethod === 'emessage' && !force) {
       return ;
    }


    this.loadingTotal = true;
    this.currentMessage.shippingMethod = shippingMethod;
    const letterId = this.currentMessage && this.currentMessage.id;
    if (letterId) {
      this.dpOfferBlockUntilNotSaving = true;
      this.dpOfferPendingContextKey = this.dpOfferContextKey(letterId);
    }
    this.draftManager
    .forceSave(this.currentMessage, { st_eligible: true })
    .subscribe((letter) => {
      this.applySavedLetterToCurrentMessage(this.currentMessage, letter)
      this.store
      .select((state) => state.createMessage)
      .pipe(debounceTime(1200))
      .take(1)
      .subscribe((currentMessage) => {
        this.loadingTotal = false;
        if (currentMessage && ((currentMessage.meta.letterCreditAmt || 0) + 5 < currentMessage.meta.letterCreditsDue)) {
          this.currentMessage.creditOption = '10';
          this.updateCreditOptionInt();
          if (this.creditOptionForm) {
            this.creditOptionForm.setValue({
              creditOption: '10',
            })
          }
        }
        this.updateEmessageReminderVisibility();
        this.updateCalculatedTotals();
      });
    });
    setTimeout(() => {
      this.currentMessage.shippingMethod = shippingMethod;
    }, 1500)
  };

	  onChangePhotoPrinting = (evt) => {
	    const selected = get(evt, 'detail.value');
	    if (!selected) return;
      if (!this.currentMessage) return;

      const isNewUser = this.user && !this.user.has_sent_letter;
      const isFirstMessagePrintMail =
        isNewUser &&
        !this.isPostcard &&
        !this.currentMessage.isResend &&
        this.currentMessage.shippingMethod === 'letter';

      if (isFirstMessagePrintMail && selected === 'none') {
        const letterId = this.currentMessage && this.currentMessage.id;
        if (letterId) {
          this.dpOfferBlockUntilNotSaving = true;
          this.dpOfferPendingContextKey = this.dpOfferContextKey(letterId);
        }

        const photos = this.currentMessage.selectedPhotos;
        if (photos && photos.length > 0) {
          this.printMailStashedPhotos = photos.slice();
        }

        this.orderOptionSelected = true;
        this.firstMessage = true;
        this.currentMessage.shippingMethod = 'letter';
        this.currentMessage.selectedPhotos = [];
        this.currentMessage.photoType = 'regular';
        this.creditTopUp = false;
        this.currentMessage.isCreditTopUp = false;
        this.currentMessage.payment = null;

        this.store.dispatch(this.createMessageActions.setMessage({
          shippingMethod: 'letter',
          selectedPhotos: [],
          photoType: 'regular',
          creditTopUp: false,
          payment: null,
        }));

        const coupon = this.currentMessage.coupon;
        const couponCode = coupon && coupon.code ? String(coupon.code).toLowerCase() : '';
        const couponId = coupon && (coupon as any).id ? (coupon as any).id : null;
        const hasSendlove = couponCode.indexOf('sendlove') >= 0;
        if (hasSendlove && !couponId) {
          // Coupon is in an optimistic/placeholder state; wait for coupon-check to resolve.
          return;
        }
        if (hasSendlove) {
          this.onSaveDraft(250, 'normal', 'photo_printing_text_only');
          return;
        }

        this.loadingTotal = true;
        this.couponCode = '#sendlove';
        // Optimistically set the coupon code in local state so the "none" radio stays selected
        // while we validate the coupon and persist it to the draft.
        this.currentMessage.coupon = { code: '#sendlove' };
        this.store.dispatch(this.createMessageActions.setMessage({ coupon: this.currentMessage.coupon }));
        this.letterService.addCoupon(this.couponCode).subscribe((resp) => {
          const nextCoupon = (resp as any) && (resp as any).coupon ? (resp as any).coupon : null;
          if (!nextCoupon) {
            this.loadingTotal = false;
            this.currentMessage.coupon = null;
            this.store.dispatch(this.createMessageActions.setMessage({ coupon: null }));
            return;
          }

          this.loadingTotal = false;
          this.currentMessage.coupon = nextCoupon;
          this.store.dispatch(this.createMessageActions.removePaymentInfo());
          this.store.dispatch(this.createMessageActions.setMessage({
            coupon: nextCoupon,
            shippingMethod: 'letter',
            selectedPhotos: [],
            photoType: 'regular',
            payment: null,
          }));

          const letterId = this.currentMessage && this.currentMessage.id;
          if (letterId) {
            this.dpOfferBlockUntilNotSaving = true;
            this.dpOfferPendingContextKey = this.dpOfferContextKey(letterId);
          }
          const nextDraftWithCoupon = {
            ...this.currentMessage,
            coupon: nextCoupon,
            shippingMethod: 'letter',
            selectedPhotos: [],
            photoType: 'regular',
            creditTopUp: false,
            payment: null,
          };
          this.store.dispatch(this.createMessageActions.saveDraft(nextDraftWithCoupon, { st_eligible: true }));
        }, () => {
          this.loadingTotal = false;
        });
        return;
      }

      // Regular / glossy selection: restore photos and remove #sendlove if present.
      if (isFirstMessagePrintMail && (selected === 'regular' || selected === 'glossy')) {
        const coupon = this.currentMessage.coupon;
        const couponCode = coupon && coupon.code ? String(coupon.code).toLowerCase() : '';
        const isSendlove = couponCode.indexOf('sendlove') >= 0;
        if (isSendlove) {
          this.currentMessage.coupon = null;
          this.couponCode = null;
          this.store.dispatch(this.createMessageActions.setMessage({ coupon: null }));
        }

        const hasPhotos = this.currentMessage.selectedPhotos && this.currentMessage.selectedPhotos.length > 0;
        if (!hasPhotos && this.printMailStashedPhotos && this.printMailStashedPhotos.length > 0) {
          this.currentMessage.selectedPhotos = this.printMailStashedPhotos.slice();
          this.store.dispatch(this.createMessageActions.setMessage({ selectedPhotos: this.currentMessage.selectedPhotos }));
        }
      }

      if (selected === 'none') return;

      this.loadingTotal = true;
      this.currentMessage.photoType = selected;
      const letterId = this.currentMessage && this.currentMessage.id;
      if (letterId) {
        this.dpOfferBlockUntilNotSaving = true;
        this.dpOfferPendingContextKey = this.dpOfferContextKey(letterId);
      }
      this.store.dispatch(this.createMessageActions.setMessage({ photoType: selected }));
      this.onSaveDraft();
      this.store
        .select((state) => state.createMessage)
        .pipe(debounceTime(1200))
        .take(1)
        .subscribe((currentMessage) => {
          this.loadingTotal = false;
          if (currentMessage && ((currentMessage.meta.letterCreditAmt || 0) + 5 < currentMessage.meta.letterCreditsDue)) {
            this.currentMessage.creditOption = '10';
            this.updateCreditOptionInt();
            if (this.creditOptionForm) {
              this.creditOptionForm.setValue({
                creditOption: '10',
              })
            }
          }
          this.updateCalculatedTotals();
        })
	  };

  canShowEmessageReminder = () => {
    if (
        !this.isPostcard && 
        !this.currentMessage.isResend && 
        this.currentMessage.shippingMethod !== 'emessage' && 
        (this.currentMessage.price > 0 || !this.user.hasSentEmessage)
    ) {
        return !!this.currentMessage.emessageAvailable;
    }
    return false;
  }

  onShowPaymentModal = async () => {
    this.pageModal = await this.modalCtrl.create({ component: AddPaymentSheet });
    await this.pageModal.present({ updateUrl: false });
  };

  onShowVerifyAccountModal = async () => {
    this.pageModal = await this.modalCtrl.create({ component: AccountVerificationModal });
    this.pageModal.onDidDismiss().then(() => {
      this.authService.authenticate().subscribe(({ user }) => {
        if (user.phone_number_verified) {
          this.onSubmit({ skipVerify: true });
        }
      });
    });
    return this.pageModal.present();
  };

  onToggleCoupon = async () => {
    const loading = await this.loadingCtrl.create({ spinner: 'dots' });

    if (this.currentMessage.coupon) {
      const nextDraft = {
        ...this.currentMessage,
        coupon: null,
        photoType: 'regular',
      };
      this.store.dispatch(this.createMessageActions.setMessage({ coupon: null, photoType: 'regular' }));
      this.loadingTotal = false;
      this.store.dispatch(this.createMessageActions.saveDraft(nextDraft, { st_eligible: true }));
      return;
    }

    await loading.present();
    this.letterService.addCoupon(this.couponCode).subscribe((resp) => {
      loading.dismiss();
      this.loadingTotal = false;
      if (resp === 404) {
        return this.onDisplayErrorAlert('Invalid code', 'OK');
      }
      if ((resp as any).error) {
        return this.onDisplayErrorAlert('Invalid code', 'OK');
      }
      this.eventService.track('add-promo-code', {
        code: this.couponCode,
        penmate_id: get(this.currentMessage, 'penmate.id'),
      });
      const nextDraft = {
        ...this.currentMessage,
        coupon: (resp as any).coupon,
        photoType: 'regular',
      };
      this.store.dispatch(this.createMessageActions.setMessage({ coupon: nextDraft.coupon, photoType: nextDraft.photoType }));
      this.store.dispatch(this.createMessageActions.removePaymentInfo());
      this.store.dispatch(this.createMessageActions.saveDraft(nextDraft, { st_eligible: true }));
    });
  };
  

  removePayment = async () => {
    const confirmRemove = await this.alertCtrl.create({
      header: 'Remove this payment method?',
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Yes',
          cssClass: 'ok',
          handler: () => {
            this.store.dispatch(this.createMessageActions.removePaymentInfo());
            this.authService.saveBilling(false).subscribe();
          },
        },
      ],
    });
    await confirmRemove.present();
  };

  onDisplayErrorAlert = async (titleText, buttonText, subHeader = null) => {
    const alert = await this.alertCtrl.create({
      cssClass: 'error-alert',
      header: titleText,
      subHeader,
      buttons: [
        {
          text: buttonText,
        },
      ],
    });
    await alert.present();
  };

  onCancel = () => {
    const penmateId = this.penmate.id;
    const url = new URL(window.location.href);
    const paymentIntentClientSecret = url.searchParams.get("setup_intent_client_secret");
    const paymentSucceeded = url.searchParams.get('paymentSucceeded');

    if (!penmateId && !paymentIntentClientSecret && !paymentSucceeded) {
      return false;
    }
    const routePath = window.location.pathname.split('/confirm-order')[0]
    this.router.navigateByUrl(routePath);
  };

  onShowAppDownloadModal = () => {
    return new Promise((resolve, reject) => {
      this.modalCtrl
        .create({
          component: AppDownloadModal,
        })
        .then(async (modal) => {
          await modal.present();
        })
        .finally(() => {
          resolve(null);
          this.eventService.track('show-app-download', {
            letter_id: this.currentMessage.id,
          });
        });
    });
  };

  convertStrToInt(str) {
    return parseInt(str);
  }

  onTrackConversion = () => {
    this.posthogReplay.stopCheckoutReplay();

    const newUserValue = 150;
    const price = this.currentMessage.priceAfterCoupon;
    const formattedValue = (this.paymentRequired && !!price ? price : newUserValue) * 0.01;
    const isResend = !!this.currentMessage.isResend;
    
    this.eventService.gaEventTrack('Sent Message', {
      event_category: 'User',
      value: formattedValue
    });
    if (!isResend) {
      this.eventService.trackSendLetterConversion({
        value: formattedValue,
        currency: 'USD',
        transaction_id: this.currentMessage.id,
      });
    }

    this.eventService.track('submit-letter-success', {
      letter_id: this.currentMessage.id,
      message_type: this.currentMessage.messageType,
      penmate_id: get(this.currentMessage, 'penmate.id'),
      purchased: !!this.paymentRequired,
      value: this.currentMessage.priceAfterCoupon,
      emessage: !!this.currentMessage.emessage,
      shipping_method: this.currentMessage.shippingMethod,
      payment_required: !!this.paymentRequired,
      credit_option: this.currentMessage.creditOption,
      price: this.currentMessage.price,
      price_after_coupon: this.currentMessage.priceAfterCoupon,
      offer_redemption_id: get(this.currentMessage, 'offerRedemptionId') || null,
      dp_has_offers: this.dpHasOffers(),
    });

    if (!!this.paymentRequired) {
      this.eventService.track('paid-order', {
        order_id: this.currentMessage.id,
        message_type: this.currentMessage.messageType,
        '$price': this.currentMessage.priceAfterCoupon,
        price: this.currentMessage.priceAfterCoupon,
        shipping_method: this.currentMessage.shippingMethod,
        credit_option: this.currentMessage.creditOption,
        offer_redemption_id: get(this.currentMessage, 'offerRedemptionId') || null,
        dp_has_offers: this.dpHasOffers(),
      })
    }
    if (!!this.currentMessage.eMessage) {
      this.eventService.track('emessage-send', {
        order_id: this.currentMessage.id,
        price: this.currentMessage.price,
        value:  this.currentMessage.price
      })
    }
  };

  onCalculateTotal() {
    const priceKey = this.couponCode ? 'priceAfterCoupon' : 'price';
    return get(this.currentMessage, priceKey) * 0.01;
  }

  onCalculateTax() {
    if (this.currentMessage) {
      const {deliveryOptions}  = get(this.currentMessage, 'meta', {});
      const shippingMethod = this.currentMessage.shippingMethod;
      if (shippingMethod && !/letter/i.test(shippingMethod) && deliveryOptions['emessage']) {
        return deliveryOptions['emessage'] * 0.01
      }
      return this.onCalculateTotal() * 0.029 + 0.3;
    }
  }
  
  onCalcMinTotal(amount) {
    return amount < 0.5 ? 0 : amount;
  }

  onCalculateTotalWithTax() {
    if (this.currentMessage) {
      const {deliveryOptions, creditOptions, processingFee}  = get(this.currentMessage, 'meta', {});
      const creditOption = creditOptions[get(this.currentMessage, 'creditOption')];
      const shippingMethod = this.currentMessage.shippingMethod
      const subtotal = this.onCalculateTotal() + (processingFee * 0.01);
      if (this.couponCode && 
        this.currentMessage.meta.firstMessage &&
        !this.isPostcard && 
        !this.user.has_sent_letter && 
        this.currentMessage.shippingMethod != 'emessage' &&
        this.currentMessage.photoType == 'regular'
      ){
        return 0;
      }
      return subtotal
    }
  }

  onCalcLetterCreditApplied() {
    if (this.currentMessage) {
      const letterCredit = this.currentMessage.meta.letterCreditBalance * 0.01;
      const { processingFee }  = get(this.currentMessage, 'meta', {});
      const subtotal = this.onCalculateTotal() + (processingFee * 0.01);
      let letterCreditAmt = this.currentMessage.meta.letterCreditApplied * 0.01;
      if (this.currentMessage.meta.letterCreditApplied > 0) {
        if (subtotal >= letterCredit ) {
          const diff = subtotal - letterCredit;
          letterCreditAmt = (diff < 0.5 ? letterCreditAmt + diff : letterCreditAmt)
        }
      }
  
      return letterCreditAmt;
    }
  }

  onCalculateRegularTotal() {
    if (this.currentMessage) {
      const {deliveryOptions, creditOptions, processingFee}  = get(this.currentMessage, 'meta', {});
      return this.onCalculateTotal() + (processingFee * 0.01);
    }
  }


  onCalculatePremiumPhotos() {
    const unitCost = this.currentMessage.meta.pricePerPhoto * 0.01;
    if (isEmpty(this.currentMessage.selectedPhotos) || 
      this.photoCredits > this.currentMessage.selectedPhotos.length
     ) {
      return unitCost;
    }
    const net_photos = this.currentMessage.selectedPhotos.length - this.photoCredits;
    const cost = unitCost * net_photos
    return cost;
  }

  onShowPhoneNumberVerify() {
    this.eventService.track('show-phone-number-verify');
    return this.onShowVerifyAccountModal();
  }

  hasFreeShipping() {
    const showFreeShipping = this.user.creditBalance > 0 || 
    this.creditTopUp || 
    this.currentMessage.coupon &&  this.currentMessage.coupon.active ||  
    !this.currentMessage.coupon && this.currentMessage.selectedPhotos.length == 0 && (this.activeSubscription) || 
    this.freeShipping || 
    this.isPostcard && !this.user.has_sent_letter
    return showFreeShipping;
  }

  onHandleSubmitError = (res) => {
    const letter = get(res, 'error.letter'); 
    const sale_object = get(letter, 'sale', {});
    this.eventService.track('submit-letter-error', {
      letter_id: this.currentMessage.id,
      message_type: this.currentMessage.messageType,
      penmate_id: get(this.currentMessage, 'penmate.id'),
      error: sale_object.error || res.error,
    });
    if (sale_object.error || get(res.error, 'payment_error')) {
      let payment_error = sale_object.error || get(res.error, 'payment_error');
      const generic_payment_err = 'There was an error with your payment method. Please try again or use a different payment card.'
      payment_error = /PaymentIntent|payment_intent/i.test(payment_error) ? generic_payment_err : payment_error;
      this.store.dispatch(this.createMessageActions.removePaymentInfo());
      return this.onDisplayErrorAlert('Payment Error', 'Try again', payment_error);
    }

    const paymentAction = get(sale_object, 'payment_action.requires_action') || false;
    const paymentIntentId = get(sale_object, 'payment_action.payment_intent_client_secret');
    if (paymentAction && paymentIntentId) {
      return this.stripe.confirmCardPayment(paymentIntentId).subscribe(async (res)=> {
        if (res.error) {
          return this.onDisplayErrorAlert('Payment Error', 'Try again', res.error.message);
        }
        const paymentIntent = get(res, 'paymentIntent', {});
        const { id: intent_id, payment_method, client_secret } = paymentIntent;
        const intentPayload = {  intent_id, payment_method, client_secret }
        const loadingModal = await this.modalCtrl.create({
          component: LoadingModal,
          componentProps: {
            message: 'Sending Message...',
          },
        });
        await loadingModal.present();
        this.letterService.confirmPayment(letter.id, intentPayload).subscribe(async (res) => {
          await loadingModal.dismiss();
          if (res.error) {
            return this.onDisplayErrorAlert('Payment Error', 'Try again');
          }
          this.onHandleSubmitSuccess();
        })
      })
    }

    ErrorHandler.captureMessage('Submit Letter Error', { error: res.error });
    return this.onDisplayErrorAlert('Sorry, there was an error', 'Try again');
  }

  onConfirmMissingPhotos = async () => {
    const alert = await this.alertCtrl.create({
      header: `Dont forget your free photos!`,
      cssClass: 'return-address-info',
      message: `Photos are free with your first message, you only pay shipping.  Would you like to add photos?`,
      buttons: [
        {
          cssClass: 'secondary',
          text: 'No, send without photos',
          handler: () => {
            this.onSubmit({ skipConfirmPhotos: true, confirm: true});
          },
        },
        {
          cssClass: 'primary',
          text: 'Yes, I want to add photos',
          handler: () => {
            if (this.currentMessage.selectedPhotos.length == 0) {
              return this.onCancel()
            }
            this.onTogglePremiumUpgrade(false)
          },
        },
      ],
    });
    await alert.present();
  };

  onHandleSubmitSuccess = () => {
    this.onTrackConversion();
    this.store.dispatch(this.myPenmateActions.viewPenmate(this.currentMessage.penmate));
    this.store.dispatch(this.createMessageActions.resetMessage());

    const penmateId = this.currentMessage.penmate.id;
    this.store.dispatch(this.myPenmateActions.loadMessages(penmateId))
    this.navCtrl.navigateRoot(`/penmates/${penmateId}/messages`);

    this.nativeService.sendMessage({
      type: 'SUBMIT_LETTER ',
      data: { ...this.currentMessage.penmate },
    });

    if (!this.nativeService.active) {
      this.onShowAppDownloadModal();
    }
  }

  onHandleSubmit = debounce((opts: any = {}) => {
    this.onSubmit(opts);
  }, 3000, { leading: true, trailing: false});

  onSubmit = async (opts: any = {}) => {

    if (this.currentMessage.eMessage && !opts.confirm) {
      return this.onConfirmEmessage();
    }

    if (!this.currentMessage.eMessage && !opts.confirm) {
      return this.onConfirmSendMessage();
    }

    if (
      this.currentMessage.coupon &&
      this.currentMessage.coupon.active &&
      !opts.skipConfirmPhotos 
    ) {
      return this.onConfirmMissingPhotos();
    }

    if (!this.returnAddressValid) {
      this.showEditAddress = true;
      return;
    }
    if (
      !opts.skipVerify &&
      !this.paymentRequired &&
      get(this.user, 'hasPurchasedCredits') !== true &&
      this.currentMessage.payment === null &&
      !get(this.user, 'phone_number_verified')
    ) {
      return this.onShowPhoneNumberVerify();
    }

    const draftPersisted = await this.persistLatestDraftBeforeSubmit();
    if (!draftPersisted) {
      await this.onDisplayErrorAlert(
        'Unable to send message',
        'OK',
        'We could not save your latest changes. Please try again.'
      );
      return;
    }

    this.eventService.track('submit-letter-start', {
      letter_id: this.currentMessage.id,
      message_type: this.currentMessage.messageType,
      penmate_id: get(this.currentMessage, 'penmate.id'),
      shipping_method: this.currentMessage.shippingMethod,
      payment_required: !!this.paymentRequired,
      credit_option: this.currentMessage.creditOption,
      price: this.currentMessage.price,
      price_after_coupon: this.currentMessage.priceAfterCoupon,
      offer_redemption_id: get(this.currentMessage, 'offerRedemptionId') || null,
      dp_has_offers: this.dpHasOffers(),
    });

    const loadingModal = await this.modalCtrl.create({
      component: LoadingModal,
      componentProps: {
        message: 'Sending Message...',
      },
    });
    await loadingModal.present();

    setTimeout(() => {
      this.letterService.sendLetter(this.currentMessage.id).subscribe(async (res) => {
        await loadingModal.dismiss();
        const returnAddressValid = get(res, 'data.return_address_valid') || true
        if (!returnAddressValid) {
          const returnAddress = get(res, 'data.returnAddress') || {};
          this.pageModal = await this.modalCtrl.create({
            component: CreateMessageReturnAddress,
            componentProps: { penmateId: res.inmate.id, returnAddress, addressConfirmation: true },
          }).then(async (modal) => {
            await modal.present();
            modal.onDidDismiss().then((payload: any) => {
              this.onHandleSubmitSuccess()
            });
          }); 
          return;
        };
        if (res.error) {
          return this.onHandleSubmitError(res);
        }
        this.onHandleSubmitSuccess()
      });
    }, 500);
  };

  private async persistLatestDraftBeforeSubmit(): Promise<boolean> {
    if (!this.currentMessage || !this.currentMessage.penmate) {
      return true;
    }

    try {
      this.draftManager.cancelPendingSaves();
      if (this.currentMessage.meta && this.currentMessage.meta.hasLetterCredit) {
        this.paymentRequired = this.currentMessage.meta.letterCreditsDue > this.currentMessage.meta.letterCreditAmt;
      }
      this.store.dispatch(this.createMessageActions.setMessage(this.currentMessage));
      const save$ = this.draftManager.forceSave(this.currentMessage, { st_eligible: true });

      if (!save$ || typeof save$.toPromise !== 'function') {
        return true;
      }

      const letter = await save$.toPromise();

      if (letter) {
        const message = Object.assign({}, this.currentMessage, letter);
        const updatedMessage = {
          ...message,
          isResend: message.is_resend,
          defaultReturnAddress: message.default_from_address,
          numberOfPages: message.number_of_pages,
          emessageAvailable: message.emessage_available,
          messageType: this.currentMessage ? this.currentMessage.messageType : message.messageType,
        };

        this.currentMessage = updatedMessage;

        this.store.dispatch(this.createMessageActions.setMessage(updatedMessage));
      } else {
        this.store.dispatch(this.createMessageActions.setMessage(this.currentMessage));
      }
      return true;
    } catch (error) {
      ErrorHandler.captureException(error, 'confirm-order-force-save', {
        letter_id: this.currentMessage ? this.currentMessage.id : null,
        penmate_id: get(this.currentMessage, 'penmate.id'),
      });
      return false;
    }
  }

	  private applySavedLetterToCurrentMessage(draft: any, letter: any): void {
	    if (!letter || letter.error) {
	      return;
	    }

    const baseMessage =
      this.currentMessage && letter && this.currentMessage.id === letter.id
        ? this.currentMessage
        : draft;
    const message = Object.assign({}, baseMessage, letter);
	    const updatedMessage = {
	      ...message,
	      isResend: message.is_resend,
	      defaultReturnAddress: message.default_from_address,
	      numberOfPages: message.number_of_pages,
	      emessageAvailable: message.emessage_available,
	      messageType: baseMessage ? baseMessage.messageType : message.messageType,
	    };

	    this.currentMessage = updatedMessage;
	    this.store.dispatch(this.createMessageActions.setMessage(updatedMessage));
	  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
